import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Models
export interface service {
    id: number,
    name?: string,
    description?: string,
    serial_no?:any,
    min_area?: string,
    unit?: string,
    code?:string
}

export interface glassWorkPrice {
    pid: number,
    price: number,
    gid: number,
    gname: string,
    gcode: number,
    is_priced: number,
    gwid: number,
    gwname: string,
    gwcode: number,
    min_area: number,
    unit: string,
    code:number,
    name:string
}
interface iService {[key:number]:service[]}
// Services state
export interface servicesState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    service?: service,
    services:iService ,
    glassWorkPrices:glassWorkPrice[] ,
    showService:boolean,
    page:number
}

const initialservicesState: servicesState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    services: {},
    glassWorkPrices: [],
    showService:false,
    page:1
}

// Services slice
export const servicesSlice = createSlice({
    name: 'services',
    initialState: initialservicesState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        setService: (state, { payload }: PayloadAction<{ service?: service }>) => {
            state.service = payload.service;
        },
        initializeServices:(state, { payload }: PayloadAction<service[]>) => {
          
            state.services[state.page] = [...payload]
        },
        addServices: (state, { payload }: PayloadAction<service[]>) => {
       
            state.services[state.page] =    state.services[state.page]?
            [...   state.services[state.page], ...payload]: [...payload]
        },
        updateService: (state, { payload }: PayloadAction<service>) => {
            let index =    state.services[state.page].findIndex(service => service.id === payload.id)
            if (index !== -1)
            state.services[state.page][index] = payload
        },
        deleteServices: (state, { payload }: PayloadAction<number[]>) => {
          
            payload.map(id => {
                let index =    state.services[state.page].findIndex(service => service.id === id)
                if (index != -1){

                    state.services[state.page].splice(index, 1)
                }
            })
        },
        addGlassWorkPrices: (state, { payload }: PayloadAction<glassWorkPrice[]>) => {
            state.glassWorkPrices=
             payload.map(elem=>({...elem,name:elem.gname || elem.name,code:elem.gcode || elem.code}))
        },
        updateGlassWorkPrice: (state, { payload }: PayloadAction<glassWorkPrice>) => {
            let index = state.glassWorkPrices.findIndex(glassWorkPrice => glassWorkPrice.pid === payload.pid)
            if (index !== -1)
            state.glassWorkPrices[index] = payload
        },
        deleteGlassWorkPrices: (state, { payload }: PayloadAction<number>) => {
            let index = state.glassWorkPrices.findIndex(glassWorkPrice => glassWorkPrice.pid === payload)
            if (index != -1)
            state.glassWorkPrices.splice(index, 1)
        },
        reset: (state) => {
            state.services = []
            state.hasMore = true
        },
        setShowService:(state,action)=>{
            state.showService=action.payload
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        }
    }
})